import { ApiFabricator } from '@app/tests/utils/fabricators/ApiFabricator'

import type { ApiPlace, ApiRegion } from '@app/packages/api/v2/types/entities'

export class ApiRegionFabricator extends ApiFabricator<ApiRegion> {
  protected getBase = (): ApiRegion => ({
    type: 'regions',
    id: ApiFabricator.getId('regions'),
    attributes: {
      available: true,
      commission_fee: '0.00',
      currency: 'RUB',
      interview: null,
      name: 'Москва',
      online_interview: null,
      online_school: null,
      parent_support_phone: '',
      prepositional_name: 'Москве',
      school: null,
      sitter_support_phone: '',
      slug: 'msk',
      subscription_options: [],
      timezone: 'Europe/Moscow',
      type: 'city',
      utc_offset: 10800,
      service_presence: true,
      test_mode: false,
    },
    relationships: {
      default_place: { meta: { included: false } },
    },
  })

  bindPlace(place: ApiPlace) {
    return this.setRelationship('default_place', { data: { id: place.id, type: 'places' } })
  }
}
